import React from 'react';
import ProjectCard from '../components/ProjectCard';
import ListPage from '../components/ListPage';
import { caseStudies, getHeroImageSrc } from '../data/caseStudies';

const Work = () => (
  <ListPage
    title="Projects"
    intro="A collection of my case studies revolving around UX and product-focused design."
    items={caseStudies}
    renderItem={(study) => (
      <ProjectCard
        key={study.id}
        full
        project={{
          url: `/work/${study.id}`,
          image: getHeroImageSrc(study),
          title: study.title,
          description: study.subtitle,
          year: study.year,
          tags: study.tags,
        }}
      />
    )}
    cta={{ label: "See what else I've built", title: 'Side Projects', to: '/side-projects' }}
  />
);

export default Work;
